<script setup>

import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="240px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div  style="width: 660px;">责任单位{{index+1}}</div>
          <div v-show="notExistInReceviedList(sItem)">
            <el-button v-if="index !== 0" type="text" icon="el-icon-delete" @click="delResponsibleUnit(index)">删除</el-button>
          </div>
        </div>
        <el-form-item :label="`指派${placeHolderInfo}责任单位人员`" :prop="`suggestionItems.${index}.assignUser`" :rules="rules.assignUser">
          <el-select filterable clearable v-model="sItem.assignUser" :placeholder="`请选择指派${placeHolderInfo}责任单位人员`">
            <el-option
              v-for="item in filterOptionUser(sItem)"
              :key="item.staffAccountId"
              :label="item.staffName"
              :value="item.staffAccountId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理意见">
          <el-input type="textarea" placeholder="请输入处理意见" v-model="sItem.handSuggestion" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="sItem.file"
            :httpRequest="imAction"/>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="text"  @click="addWeightUser" icon="el-icon-plus">{{`新增指派${placeHolderInfo}责任单位人员`}}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
        <el-button v-show="this.suggestionItems && this.suggestionItems.length > 0 && this.suggestionItems[0].assignUser != ''  &&
        (this.taskDefKey == 'Activity_0th0wyq' || this.taskDefKey == 'Activity_074ozpu')"
                   class="lang-but" type="primary" @click="auditPassNotUnitBtClick">不再指定责任人员</el-button>
        <el-button v-show="this.marketVehiclesList && this.marketVehiclesList.length > 0 && this.marketVehiclesList[0].userId != ''  &&
        (this.taskDefKey == 'Activity_1ymzrv7' || this.taskDefKey == 'Activity_0xqs0a8')"
                   class="lang-but" type="primary" @click="auditPassNotUnitBtClick">不再指定责任人员</el-button>
        <el-button v-show="taskDefKey!= 'Activity_1ymzrv7' && taskDefKey != 'Activity_0xqs0a8' " class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
      </el-form-item>
    </el-form>

    <!-- 审核通过意见弹窗 -->
    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules"  ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>
<script>
import {getAccountUnitUserKDList, getAccountUnitUserList} from "../../api/api";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  components: { KdAuditPassDialog },
  name: "kdQeAssignAccountUnitAudit",
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    suggestionItems:{
      type: Array,
      default:() => []
    },
    marketVehiclesList:{
      type: Array,
      default:() => []
    }
  },
  data() {
    return {
      placeHolderInfo:"",
      auditPassDialogVisible: false,
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      userOptions:[],
      assignUser:"",
      dialogVisible:false,
      existSuggestionItems:[],
      form:{
        auditText:"",
        suggestionItems:[
          {
            assignUser: "",
            handSuggestion: "",
            file: []
          }
        ],
        rejectReason: "",
      },
      rules: {
        assignUser: [
          { required: true,  message: `指派责任单位人员不能为空`,  trigger: ['blur', "change"] }
        ],
        rejectReason: [
          { required: true, message: "驳回原因不能为空", trigger: ["blur", "change"] }
        ],
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    filterOptionUser(currentUserValue){
      return this.userOptions.filter(item => item.staffAccountId === currentUserValue.assignUser || !this.form.suggestionItems.some(suggestionItem => suggestionItem.assignUser === item.staffAccountId))
    },
    notExistInReceviedList(sitem){
      if(sitem && sitem.assignUser){
        return !this.existSuggestionItems.some(item => item.assignUser === sitem.assignUser);
      }
      return true;
    },
    async auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })
    },
    async auditPassNotUnitBtClick() {
      this.$confirm("确认不再指定责任单位吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: true,
            auditPassNotUnit: true
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('审核通过!');
            this.dialogVisible = false;
            this.backRouterPath();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      });
    },

    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        // suggestionItems: this.form.suggestionItems,
        auditText: auditText,
        variables: {
          approval: true,
          auditPassNotUnit: false
        },
      }
      if (this.taskDefKey === 'Activity_0xqs0a8' || this.taskDefKey === 'Activity_187ssqr' || this.taskDefKey === 'Activity_1ymzrv7') { // 库存物料处置指定责任人员
        formData.repertorySuggestionItems = this.form.suggestionItems;
      } else {
        formData.suggestionItems = this.form.suggestionItems;
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
            auditPassNotUnit: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.dialogVisible = false;
          this.backRouterPath();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    },
    // 新增责任单位
    addWeightUser(){
      this.form.suggestionItems.push({
        assignUser: "",
        handSuggestion: "",
        file: []
      })
    },
    // 删除责任单位
    delResponsibleUnit(index) {
      this.form.suggestionItems.splice(index, 1);
    },
    listAccountUnitUser(){
      let urlSearchParams = new URLSearchParams();
      urlSearchParams.append("questionId", this.questionId);
      if (this.taskDefKey === 'Activity_0xqs0a8' || this.taskDefKey === 'Activity_1ymzrv7'){
        urlSearchParams.append("type", 2);
      }else {
        urlSearchParams.append("type", 1);
      }
      getAccountUnitUserKDList(urlSearchParams).then(res => {
        if(res.status == "0"){
          this.userOptions = res.data;
        }
      })
    }
  },
  mounted() {
    if(this.taskDefKey !== 'Activity_0xqs0a8' && this.taskDefKey !== 'Activity_1ymzrv7'){
      this.form.suggestionItems = this.suggestionItems != null?[...this.suggestionItems]:[];
      this.form.suggestionItems.forEach(item => {
        item.file = [];
      })
    }
    if(this.form.suggestionItems.length === 0){
      this.addWeightUser();
    }
    this.existSuggestionItems = this.suggestionItems != null?[...this.suggestionItems]:[];
    if(this.taskDefKey === 'Activity_0xqs0a8'){
      this.placeHolderInfo = "未发物料处理";
    }
   this.listAccountUnitUser();
  }
}
</script>
